module.exports = __webpack_public_path__ + "static/transition.14d09a24.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/transition.svg
// module id = 96
// module chunks = 0